<div 
    *ngIf="isToggledOn"
    [style.transform]="renderRotation()"
    [style.width.em]="element.width"
    [style.height.em]="getHeight() || getHeight()==0 ? getHeight() : element.height"
    [ngStyle]="getStyle()"
    [class.is-clickable]="element.isClickable"
    [class.is-animatable]="element.isAnimatable || element.isClickable"
    [class.is-revealed]="element.isOff"
    [style.pointer-events]="getPointerEvents()"
>
    <div *ngFor="let contentElement of element.content">
        <element-render 
            [contentElement]="contentElement" 
            [questionState]="questionState"
            [isLocked]="isLocked"
        ></element-render>
    </div> 
</div>
